import { FaLock, FaUnlock, FaImage } from 'react-icons/fa';
import dayjs from 'dayjs';

import {
  NoteCardContainer,
  NoteCardTitle,
  NoteCardContent,
  NoteCardMeta
} from './note-card.styles';

const NoteCard = ({ note, createdAt, onClick }) => {
  return (
    <NoteCardContainer onClick={onClick}>
      <NoteCardMeta>
        <span><strong>Created:</strong> {dayjs(createdAt).format('MMMM D, YYYY [at] h:mm A')}</span>
        <span style={{ marginLeft: '8px', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
          {note.isPublic ? <FaUnlock title="Public" /> : <FaLock title="Private" />}
          {note.images?.length > 0 && <FaImage title="Has Image" />}
        </span>
      </NoteCardMeta>

      <NoteCardTitle>
        {note.type || 'Note'}
        
      </NoteCardTitle>

      <NoteCardContent>{note.content.slice(0, 80)}...</NoteCardContent>
    </NoteCardContainer>
  );
};

export default NoteCard;